var _rect, _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabDiagnosticsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 9,
    fill: "url(#paint0_linear_11449_46919)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.333 13.0651H25.6663",
    stroke: "#42ADA7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.333 26.3971H27.6663",
    stroke: "#42ADA7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3329 13.0664V21.0664L31.2329 29.5589C31.9409 30.4303 31.3209 31.7331 30.1981 31.7331H11.8007C10.678 31.7331 10.0579 30.4303 10.7659 29.5589L17.6662 21.0664V13.0664",
    stroke: "#42ADA7",
    strokeWidth: 2.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.9997,
    cy: 9.73307,
    rx: 0.666666,
    ry: 0.666667,
    fill: "#42ADA7"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.9997,
    cy: 7.0651,
    rx: 0.666669,
    ry: 0.666667,
    fill: "#42ADA7"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.6663,
    cy: 10.3997,
    rx: 1.33333,
    ry: 1.33333,
    fill: "#42ADA7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11449_46919",
    x1: 7,
    y1: 6.5,
    x2: 85.5,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDFAF9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabDiagnosticsIcon);
export default __webpack_public_path__ + "static/media/LabDiagnosticsIcon.7efed8c1ad8425ee6296973e9f35b57e.svg";
export { ForwardRef as ReactComponent };